import { UiFooter, UiNewsletter } from "libs/raas-ui-react-components/src/components";
import { useTranslation } from "react-i18next";
import { getNewsletterLiterals } from "./PrivatePagesWrapper.util";

export default function PrivatePagesWrapper({ children }: any) {

    const [t, i18n] = useTranslation("global");

    const literalsNewsletter = getNewsletterLiterals(t);
    const footerLiterals = {
        title1:  t("footerLiterals.title1"),
        subtext1: t("footerLiterals.subtext1"),
        title2: t("footerLiterals.title2"),
        subtext2_1: t("footerLiterals.subtext2_1"),
        subtext2_2: t("footerLiterals.subtext2_2"),
        subtext2_3:t("footerLiterals.subtext2_3"),
        title3: t("footerLiterals.title3"),
        subtext3_1: t("footerLiterals.subtext3_1"),
        subtext3_2: t("footerLiterals.subtext3_2"),
        subtext3_3: t("footerLiterals.subtext3_3"),
        title4: t("footerLiterals.title4"),
        subtext4_1: t("footerLiterals.subtext4_1"),
        subtext4_2: t("footerLiterals.subtext4_2"),
        subtext4_3: t("footerLiterals.subtext4_3"),
        linkdeIn:  t("footerLiterals.linkdeIn"),
        youtube:  t("footerLiterals.youtube"),
        facebook:  t("footerLiterals.facebook"),
        instagram:  t("footerLiterals.instagram"),
        twitter:  t("footerLiterals.twitter"),
        url:{
            howDoesItWork:t("footerLiterals.url.howDoesItWork"),
            aboutDoco:t("footerLiterals.url.aboutDoco"),
            blog:t("footerLiterals.url.blog"),
            privacyPolicy:t("footerLiterals.url.privacyPolicy"),
            termsConditions:t("footerLiterals.url.termsConditions"),
            cookiePolicy:t("footerLiterals.url.cookiePolicy"),
            help:t("footerLiterals.url.help"),
            webMap:t("footerLiterals.url.webMap"),
        }
    }

    return (
        <>
            <UiNewsletter literals={literalsNewsletter}></UiNewsletter>
            <UiFooter literals={footerLiterals}></UiFooter>
        </>
    )

}
